import { YoastMeta } from '@/types/yoast-meta';
import replaceCmsUrl from '@/utils/functions/wordpress/replace-cms-url';

const mapYoastMeta = (meta?: YoastMeta): YoastMeta => {
    return {
        ...meta,
        title: meta?.title || 'News and insights about digital assets',
        og_url: replaceCmsUrl(meta?.og_url),
        canonical: replaceCmsUrl(meta?.canonical),
        schema: meta?.schema
            ? JSON.parse(
                  // Fix cms. addresses in schema object, but not for wp-content urls (which are images)
                  JSON.stringify(meta!.schema).replace(
                      /"https?:\/\/cms\.blockworks\.co((?!\/wp-content).*?)"/g,
                      '"https://blockworks.co$1"',
                  ),
              )
            : null,
    };
};

export default mapYoastMeta;
